// extracted by mini-css-extract-plugin
module.exports = {"container":"aftercare_container__1ofw0","content":"aftercare_content__3k2xb","menuRow":"aftercare_menuRow__1lbhm"};